import React, {useState, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {FORM_ERROR} from 'final-form';
import {Form} from 'react-final-form';

import StatusAlert from '../StatusAlert';
import ContactInfo from './ContactInfo';
import TermsAndConditions from './TermsAndConditions';
import {
  FieldsContainer,
  FormTitle,
  SubmitButton,
} from '../../utils/commonStyledComponents';
import {FormError} from './';
import {mutators, memberInitialValues} from './utils';
import {validateUpdateMember} from '../Form/validation';
import {useUser} from '../../utils/UserSession';
import {updateMemberInfo} from '../../utils/api';

// Rebranding 2026 · UpdateMember → gc-card2 head petrolio "Titolare account · Informazioni personali"

const UpdateMember = ({cities}) => {
  const {user, setUser} = useUser();
  const [showAlert, setShowAlert] = useState(false);

  const onSubmit = useCallback(
    async data => {
      try {
        const confirmedData = await updateMemberInfo(data);

        const updatedUser = {...user, ...confirmedData};

        setUser(updatedUser);

        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 4000);
      } catch (e) {
        const {data} = e.response || {};

        if (data.errors) {
          return data.errors;
        }

        return {
          [FORM_ERROR]:
            data.message ||
            'Si è verificato un errore nella comunicazione con il server',
        };
      }
    },
    [setUser, user]
  );

  const initialValues = useMemo(() => memberInitialValues(user), [user]);

  return (
    <Form
      onSubmit={onSubmit}
      mutators={mutators}
      initialValues={initialValues}
      validate={validateUpdateMember}
      render={({
        values,
        form,
        handleSubmit,
        submitting,
        submitError,
        hasValidationErrors,
      }) => (
        <form onSubmit={handleSubmit} noValidate={true}>
          <div className="gc-card2" style={{marginBottom: 24}}>
            <div className="gc-card2__head gc-card2__head--petrolio">
              <span className="gc-iconbadge gc-iconbadge--petrolio">
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </span>
              <div>
                <p className="gc-card2__eyebrow">Titolare account</p>
                <h3 className="gc-card2__title">Informazioni personali</h3>
              </div>
            </div>
            <div className="gc-card2__body">
              <FieldsContainer>
                {!submitting && submitError && (
                  <FormError>{submitError}</FormError>
                )}

                {/* FormTitle legacy mantenuto come anchor (nascosto visivamente, l'head card lo sostituisce) */}
                <FormTitle style={{display: 'none'}}>Informazioni Personali</FormTitle>

                <ContactInfo values={values} cities={cities} form={form} />

                <TermsAndConditions values={values} />
              </FieldsContainer>

              <SubmitButton
                text="Aggiorna"
                loading={submitting}
                disabled={submitting || hasValidationErrors}
              />

              <StatusAlert visible={showAlert}>
                Aggiornamento avvenuto con successo
              </StatusAlert>
            </div>
          </div>
        </form>
      )}
    />
  );
};

UpdateMember.propTypes = {
  cities: PropTypes.array,
};

export default UpdateMember;
